<script lang="ts">
  import { params, redirect } from "@sveltech/routify";

  let id = $params['id'];

  let firebase = window.firebase;

  let data : Offer_v2;

  async function getOffer() {
    await firebase
      .firestore()
      .collection("offers_v2")
      .doc(id)
      .get()
      .then((doc) => {
        data = doc.data() as Offer_v2;
      });
  }

  let requests : Request_v2_Doc[];

  async function getRequests() {
    await firebase
      .firestore()
      .collection("requests_v2")
      .where("offer", "==", id)
      .get()
      .then((docs) => {
        requests = docs.docs.map( doc => ({ id: doc.id, data: doc.data() as Request_v2 }));
      });
  }

  Promise.all([
    getOffer(),
    getRequests()
  ]).then(() => {
    _redirect();
  })

  function _redirect() {
    if (data.status === 'draft' || data.status === 'pending-approval' || data.status === undefined) {
      $redirect("../details");
    } else if (requests.find(req => req.data.status === 'selected' || req.data.status === 'matched' || req.data.status === 'completed' || req.data.status === 'failed')) {
      $redirect("../matches");
    } else {
      $redirect("../requests");
    }
  }

  
</script>
